import {
	Service, SqlEditorOptions,
	SqlExecOptions, SqlExecCallbackArgs, SqlColumn, SqlError
} from "@reporting/rp-app-host";
import { Parameter, Thread } from "@reporting/rp-types/etl";
import { CsvArrayStream } from '@reporting/rp-utils-csv';
import { ThreadSqlEditorAdapter } from "./threadSqlEditorAdapter";


export class ParamSqlEditorAdapter extends ThreadSqlEditorAdapter {

	constructor(
		etlClient: Service,
		private parameter: Parameter,
		private type: 'content'|'value'
	) { super(etlClient, {id_thread: 0}) }


	async getContent() : Promise<string> {
		const p = await this.etlClient.get<Parameter>(`threads/${this.parameter.id_thread}/parameters/${this.parameter.idz}`);
		return this.type == 'content' ? p.content : p.default_value;
	}

	async save(sql: string) {
		// every save soft-deletes the current row and inserts a new one, so the idz changes
		const saved = await this.etlClient.post<Parameter>(`threads/${this.parameter.id_thread}/parameters`, (this.type == 'content' ? {
			idz: this.parameter.idz,
			content: sql
		} : {
			idz: this.parameter.idz,
			default_value: sql
		}) as Parameter);

		if (saved?.idz) this.parameter.idz = saved.idz;
	}

	getOptions(): SqlEditorOptions {
		return this.createOptions({history: false});
	}

}
